import config from "config/config";

export const GTM_ID = config.gtmCode;

export const gtmConsentModeScript = `
// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
// Default ad_storage and analytics_storage to 'denied'.
// gtag('consent', 'default', {
//     'ad_storage': 'granted',
//     'analytics_storage': 'granted',
//     'wait_for_update': 500,
//     'region': ['US-CA'],
//    });
gtag('consent', 'default', {
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'wait_for_update': 500
});
`;

export const oneTrustTriggerScript = `function OptanonWrapper() {}`;

export const gtmScript = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}')
`;
